import { tryCatchHelper } from '../../../helpers';
import {
  ACTIVO_USU_VISTAS,
  ALL_USU_VISTAS,
  LOADING_ALL_USU_VISTAS,
} from './UsuVistasReducer';
import {
  allUsuVistasService,
  deleteUsuVistasService,
  saveUsuVistasService,
} from './UsuVistasService';

export const allUsuVistasAction = async (
  { dispatch, isLogin = false },
  params,
) => {
  try {
    dispatch({ type: LOADING_ALL_USU_VISTAS, payload: true });
    const res = await allUsuVistasService(params);
    if (!isLogin) {
      dispatch({ type: ALL_USU_VISTAS, payload: res.data });
    }
    dispatch({ type: LOADING_ALL_USU_VISTAS, payload: false });
    return res.data.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_USU_VISTAS, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const saveUsuVistasAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await saveUsuVistasService(id, data);
    notify(res.data.message);
    await allUsuVistasAction({ dispatch }, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoUsuVistasAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_USU_VISTAS, payload: data });
};

export const deleteUsuVistasAction = async (
  { dispatch, notify },
  id,
  params,
) => {
  try {
    const res = await deleteUsuVistasService(id);
    notify(res.data.message);
    await setActivoUsuVistasAction(dispatch, null);
    await allUsuVistasAction({ dispatch }, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};
